import { mediaItems } from '@/mocks/home';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">秒开抢先看</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            精选热门影片，4K超清画质，即点即播流畅不缓冲
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-500/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/80 via-transparent to-transparent"></div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-16 h-16 rounded-full bg-primary-500/90 flex items-center justify-center">
                    <i className="ri-play-fill text-2xl text-background-50 w-6 h-6 flex items-center justify-center"></i>
                  </div>
                </div>
                <div className="absolute top-3 right-3 flex items-center gap-2">
                  <span className="px-2 py-1 rounded-md bg-background-50/80 backdrop-blur-sm text-xs font-medium text-foreground-800 whitespace-nowrap">
                    {item.quality}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3">
                  <span className="px-2 py-1 rounded-md bg-accent-500/80 text-xs font-medium text-background-50 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 mt-1.5 line-clamp-2">{item.description}</p>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line w-3 h-3 flex items-center justify-center"></i>
                    {item.duration}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="#index"
            className="whitespace-nowrap inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-600 text-sm font-medium hover:border-primary-500 hover:text-primary-500 transition-all duration-200 cursor-pointer"
          >
            浏览全部影片
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}